import { MessageContainer } from "./MessageContainer";
import { getMessageStatusTooltip, MessageStatus } from "./MessageStatus";
import { MessageAudio } from "./types/Audio";
import { MessageFile } from "./types/File";
import { MessageImage } from "./types/Image";
import { MessageText } from "./types/Text";
import { MessageVideo, isVideoMessage } from "./types/Video";

const MESSAGE_COMPONENTS = {
  audio: MessageAudio,
  file: MessageFile,
  image: MessageImage,
  plainText: MessageText,
  video: MessageVideo,
};

const IMAGE_CONTENT_TYPES = new Set([
  ".jpeg",
  ".jpg",
  ".png",
  ".gif",
  ".bmp",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/webp",
  "image/heic",
  "image/heif",
]);

const resolveMessageComponent = (message, textComponent) => {
  const category = message?.content?.category;
  const TextRenderer = textComponent ?? MessageText;

  if (category === "plainText") {
    return TextRenderer;
  }

  if (category && MESSAGE_COMPONENTS[category]) {
    return MESSAGE_COMPONENTS[category];
  }

  if (isVideoMessage(message)) {
    return MessageVideo;
  }

  const contentType = String(message?.content?.type ?? "").toLowerCase();
  if (IMAGE_CONTENT_TYPES.has(contentType)) {
    return MessageImage;
  }

  return TextRenderer;
};

export const Message = ({ message, sender, onOpenImagePreview, maskNonOwnSenderName, resolveIsRead, textComponent, bubbleAccent }) => {
  const isOwn =
    message.sender?.type === sender?.type &&
    (message.sender?.uid && sender?.uid
      ? message.sender.uid === sender.uid
      : Number(message.sender?.id) === Number(sender?.id));

  const Component = resolveMessageComponent(message, textComponent);
  const isRead = resolveIsRead ? resolveIsRead(message) : undefined;

  return (
    <MessageContainer
      isOwn={isOwn}
      message={message}
      senderDisplayName={!isOwn ? maskNonOwnSenderName : undefined}
      statusSlot={isOwn ? <MessageStatus message={message} isRead={isRead} /> : undefined}
      bubbleTooltip={isOwn ? getMessageStatusTooltip(isRead ?? Boolean(message?.readAt), message) : undefined}
      bubbleAccent={bubbleAccent}
    >
      <Component isOwn={isOwn} message={message} sender={sender} onOpenImagePreview={onOpenImagePreview} />
    </MessageContainer>
  );
};
